import { useMemo } from "react";
import { CHART_COLORS } from "@/components/analytics/ChartCanvas";
import type { EmployeeKpiRow } from "@/lib/reporting.api";

export function useEmployeeValueChartConfig(rows: EmployeeKpiRow[]) {
  return useMemo(
    () => ({
      type: "bar" as const,
      data: {
        labels: rows.map((row) => row.name),
        datasets: [
          {
            label: "Valeur (XAF)",
            data: rows.map((row) => row.value),
            backgroundColor: CHART_COLORS.primary,
            borderRadius: 4,
          },
        ],
      },
      options: {
        indexAxis: "y" as const,
        plugins: { legend: { display: false } },
        scales: {
          x: {
            ticks: { font: { size: 11 }, color: CHART_COLORS.muted },
            grid: { color: CHART_COLORS.grid },
            beginAtZero: true,
          },
          y: {
            ticks: { font: { size: 11 }, color: CHART_COLORS.muted },
            grid: { display: false },
          },
        },
      },
    }),
    [rows],
  );
}
